import React from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, ModalShell, Text } from '@/components/ui';
import { i18nKeys } from '@/i18n/i18nKeyGen';
import { GuideButton } from '@/features/guide';
import CompanySubscriptionSettingsForm from './CompanySubscriptionSettingsForm';

interface CompanySubscriptionSettingsModalProps {
  isOpen: boolean;
  companyId: number | null;
  onClose: () => void;
  onSaved?: () => void;
}

const CompanySubscriptionSettingsModal: React.FC<CompanySubscriptionSettingsModalProps> = ({
  isOpen,
  companyId,
  onClose,
  onSaved,
}) => {
  const { t } = useTranslation(['company']);

  if (!companyId) return null;

  return (
    <ModalShell
      isOpen={isOpen}
      title={t(i18nKeys.company.subscription_settings)}
      onClose={onClose}
      size="lg"
      titleAddon={<GuideButton guideKey="companySubscription" iconOnly iconSize={18} />}
    >
      <Flex direction="column" gap={4} align="stretch">
        <Text size="sm" color="textSecondary" data-tour="subscription-intro">
          {t(i18nKeys.company.subscription_settings_email_notice)}
        </Text>
        <CompanySubscriptionSettingsForm
          companyId={companyId}
          isActive={isOpen}
          onSaved={() => {
            onSaved?.();
            onClose();
          }}
        />
      </Flex>
    </ModalShell>
  );
};

export default CompanySubscriptionSettingsModal;
